import { Input } from "antd";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BiSearch } from "react-icons/bi";

export default function CommonSearch({ setPageConfig, placeholder }) {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState("");

  const onSearchChange = (e) => {
    if (e.target.value === "") {
      setPageConfig((prev) => {
        const { key, ...rest } = prev;
        return key ? { ...rest, page: 1, count: 10 } : prev;
      });
    }
    setInputValue(e.target.value);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setPageConfig((prev) => {
        return {
          ...prev,
          page: 1,
          key: inputValue,
        };
      });
    }, 500);

    return () => clearTimeout(timer);
  }, [inputValue, setPageConfig]);

  return (
    <div className="common-search w-full sm:w-[250px]">
      <Input
        prefix={<BiSearch className="text-gray-400 mx-2" />}
        className="w-full bg-transparent"
        size="large"
        placeholder={placeholder || t("common.search")}
        value={inputValue}
        onChange={onSearchChange}
        allowClear
      />
    </div>
  );
}
